module.exports = __webpack_public_path__ + "static/media/odoo.e346acae.png";